import React from "react"
import styles from "./overflow-menu-item.module.css"
import Skeleton from "@/components/skeleton/skeleton.tsx"
import { cn } from "@/utils/styles.ts"

interface TaskSettingCardProps {
  children: React.ReactNode
  isDisabled?: boolean
  marginInline?: boolean
  onClick?: () => void
  minHeight?: number
  height?: number
  isLoading?: boolean
  skeletonHeight?: number
  className?: string
  isDisabledButVisible?: boolean
}

const OverflowMenuItem: React.FC<TaskSettingCardProps> = ({
  children,
  isDisabled = false,
  onClick,
  minHeight,
  height,
  isLoading,
  skeletonHeight,
  className,
  isDisabledButVisible,
}) => {
  const propStyle = {
    minHeight: minHeight,
    height: height,
  }

  return (
    <div
      className={cn(
        styles.overflowMenuItem,
        className,
        isDisabledButVisible && styles.disabledButVisible,
      )}
      data-is-loading={isLoading}
      style={isLoading ? undefined : propStyle}
      data-disabled={isDisabled}
      onClick={onClick}
    >
      {isLoading ? <Skeleton height={skeletonHeight} /> : children}
    </div>
  )
}

export default OverflowMenuItem
